// extracted by css-extract-rspack-plugin
export default {"wrapper":"TaskAutosaveToggle_wrapper__u8csF"};